'use client';

import React from 'react';
import { createSearchClient, SearchClient } from '@workspace/lib';
import { InstantSearch } from 'react-instantsearch';

type InstantSearchProps = React.ComponentProps<typeof InstantSearch>;

type InstantSearchProviderProps = {
  indexName?: string;
  children: React.ReactNode;
} & Omit<InstantSearchProps, 'searchClient' | 'indexName'>;

export function InstantSearchProvider({ indexName, children, ...props }: InstantSearchProviderProps) {
  const searchClient = React.useMemo(() => SearchClient ?? createSearchClient(), []);
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      future={{ preserveSharedStateOnUnmount: true }}
      insights={true}
      {...props}
    >
      {children}
    </InstantSearch>
  );
}
